angular.module 'zc.core'

.directive 'zcAdmin', ($rootScope, $location, PageLayout) ->
  restrict: 'E'
  templateUrl: '/templates/core/views/admin.html'
  link: (scope, elem, attrs) ->
    $rootScope.$on '$stateChangeSuccess', () ->
      if $location.path().indexOf('/admin/master') == 0
        PageLayout.showFooter = false
      else
        PageLayout.showFooter = true




// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/directives/admin.directive.coffee